import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmerge2027Logo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 239,
	height: 200,
	viewBox: "0 0 239 200",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_1318_27)",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M212.722 86.8565H89.8247L101.915 53.0734C104.013 47.0764 109.708 43.0784 116.103 43.0784H239L226.91 76.8615C224.812 82.8585 219.117 86.8565 212.722 86.8565Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M218.517 100.35L206.727 133.333C204.629 139.33 198.934 143.328 192.539 143.328H86.028C79.6334 143.328 73.9381 147.326 71.8399 153.323L58.6509 190.005C56.4528 196.002 50.8574 200 44.4628 200H0L12.0899 166.517C14.288 160.52 19.8834 156.522 26.278 156.522H54.5543C60.949 156.522 66.6442 152.524 68.7425 146.527L81.7316 110.345C83.9298 104.348 89.5251 100.35 95.9197 100.35H218.517Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M212.622 199.8H67.2437L79.3336 166.317C81.5318 160.32 87.1271 156.322 93.5217 156.322H238.9L226.81 189.805C224.612 195.802 219.017 199.8 212.622 199.8Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M91.3236 43.1784H39.9666L51.7567 9.995C53.8549 3.998 59.5502 0 65.9448 0H117.302L105.512 33.1834C103.413 39.1804 97.7182 43.1784 91.3236 43.1784Z" })
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1318_27",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 239,
			height: 200
		})
	}) })]
});
export default SvgEmerge2027Logo;
